<template>
  <div class="container-fluid no-gutters edit-menu-bar">
    <div class="row">
      <div class="col">
        <div class="edit-menu-container">
          <ul class="edit-menu edit-menu-horizontal">
            <li v-for="(item, index) in menuItems" class="edit-menu-item edit-menu-item-level-0" v-bind:key="index">
              <a v-bind:class="item.cssClass" :target="item.target && item.target" :href="item.href ? item.href : 'javascript:void(0)'" v-on:click="clickItem(item, $event)">{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-auto">
        <div class="edit-menu-container">
          <ul class="edit-menu edit-menu-horizontal" v-if="hasDataSetActions">
            <li class="edit-menu-item edit-menu-item-level-0" v-for="(item, index) in datasetactions" v-bind:key="index">
              <a v-bind:class="item.cssClass" href="javascript:void(0)" v-bind:title="item.title" v-on:click="clickItem(item, $event)">{{ ((item.cssClass === null) || (item.cssClass === '')) ? item.title : '' }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-auto" v-if="hasSupportUserItems && isSupportVerified">
        <div class="edit-menu-container">
          <div id="support" class="btn-group mt-2">
            <template>
              <a id="support-primary" href="javascript:void(0)" class="btn btn-light" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ this.$t('supporttasks.buttontitle') }}</a>
              <a href="javascript:void(0)" class="btn btn-light dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
              <div class="dropdown-menu dropdown-menu-right">
                <a @click="clickItem(item, $event)" class="dropdown-item" href="javascript:void(0)" v-for="(item, index) in supportUserItems" v-bind:key="index">{{ item.title }}</a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuItems: Array,
    datasetactions: Array,
    supportUserItems: Array
  },
  data () {
    return {
      isSupportVerified: false  
    };
  },
  async created () {
    this.isSupportVerified = await this.$isSupportVerified();
  },
  computed: {
    hasDataSetActions () {
      if (this.datasetactions)
        return this.datasetactions.length > 0;

      return false;
    },
    hasSupportUserItems () {
      if (this.supportUserItems)
        return this.supportUserItems.length > 0;

      return false;
    }
  },
  methods: {
    clickItem (item, ev) {
      if(ev && ev.target && ev.target.blur) {
        ev.target.blur();
      } 
      item.action();
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

.edit-menu-bar {
    background: #fff;
    border-bottom: 1px solid $sub500;
    a:link.EditMenu-Generate, a:link.editmenu-generate {padding-left: 24px; background-image: url('~@/assets/redo-solid.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}
    a:link.editmenu-create-basket {padding-left: 24px; background-image: url('~@/assets/cart-dark@2x.png'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}
    a:link.editmenu-create-offer {padding-left: 24px; background-image: url('~@/assets/order/offerrequest.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}
    a:link.editmenu-create-order {padding-left: 24px; background-image: url('~@/assets/order/order.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}
    a:link.editmenu-import {padding-left: 24px; background-image: url('~@/assets/workflow/import.png'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}
    
    a.menu-icon.options {padding-left: 24px;background-image: url('~@/assets/mi/extra-v.svg'); background-position: center center; background-repeat: no-repeat; height:39px; }
    a:link.editmenu-printer {padding-left: 24px; background-image: url('~@/assets/printer.svg'); background-size: 18px; background-position: center center; background-repeat: no-repeat; height:39px; }
    a:link.editmenu-download {padding-left: 24px; background-image: url('~@/assets/download.svg'); background-size: 18px; background-position: center center; background-repeat: no-repeat; height:39px; }
    a:link.editmenu-import {padding-left: 24px; background-image: url('~@/assets/import.svg'); background-size: 18px; background-position: center center; background-repeat: no-repeat; height:39px; }
    a:link.editmenu-export {padding-left: 24px; background-image: url('~@/assets/export.svg'); background-size: 18px; background-position: center center; background-repeat: no-repeat; height:39px; }

    a:link.editmenu-logout {padding-left: 24px; background-image: url('~@/assets/workflow/logout.svg'); background-size: 16px; background-position: center left; background-repeat: no-repeat;}
    a:link.editmenu-tree-on {padding-left: 24px; background-image: url('~@/assets/workflow/wfi-tree-blue.svg'); background-size: 18px; background-position: center center; background-repeat: no-repeat; height:39px; }
    a:link.editmenu-tree-off {padding-left: 24px; background-image: url('~@/assets/workflow/wfi-tree-gray.svg'); background-size: 18px; background-position: center center; background-repeat: no-repeat; height:39px; }
    a:link.editmenu-person {padding-left: 24px; background-image: url('~@/assets/persons.png'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}
    a:link.editmenu-notification {padding-left: 24px; background-image: url('~@/assets/bell.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}

    a:link.editmenu-export-left {padding-left: 24px; background-image: url('~@/assets/export.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat;}
    a:link.editmenu-import-left {padding-left: 24px; background-image: url('~@/assets/import.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat; }
    a:link.editmenu-export-dataset {padding-left: 24px; background-image: url('~@/assets/export.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat; margin-top:10px; }

    a:link.editmenu-hoursperweek {padding-left: 24px; background-image: url('~@/assets/calendar-hoursperweek.svg'); background-size: 24px; background-position: center center; background-repeat: no-repeat; height: 39px;}
    a:link.editmenu-history {padding-left: 24px; background-image: url('~@/assets/history-icon.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat; }
    a:link.editmenu-eventlog {padding-left: 24px; background-image: url('~@/assets/eventlog.svg'); background-size: 18px; background-position: center left; background-repeat: no-repeat; }
}
.dropdown-menu-right {
  right: 10px;
  left: auto;
}
</style>
